import { CompetitionType } from "app/types/competitionType";
import { SportsNameType } from "app/utils/const";
import React from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";

type Props = {
  text1x2: string;
  textML: string;
  competitionList: CompetitionType[];
};
const AsianEventScreenHeader1x2ML = (props: Props): React.JSX.Element => {
  const { competitionList, text1x2 } = props;
  const hasSoccer = competitionList.some(
    (comp: CompetitionType) => comp.sportType === SportsNameType.SOCCER
  );
  const hasOtherThanSoccer = competitionList.some(
    (comp: CompetitionType) => comp.sportType !== SportsNameType.SOCCER
  );
  return (
    <>
      <div className="col ft-onebytwo">
        {hasSoccer && (
          <span>
            <FormattedMessage tagName="span" id={text1x2} />
          </span>
        )}
        {hasSoccer && hasOtherThanSoccer && <span>/</span>}
        {hasOtherThanSoccer && (
          <span>
            <FormattedMessage tagName="span" id={props.textML} />
          </span>
        )}
      </div>
    </>
  );
};

const mapStateToProps = state => ({
  competitionList: state.competitionListModel.competitionList,
});

export default connect(mapStateToProps)(AsianEventScreenHeader1x2ML) as any;
